
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';


import { AppSettings } from './app.settings';
import { Catch, Factory, Recapture, Release, ICESCell } from '../core/models';
import { FactoriesHelper, CatchesHelper, RecapturesHelper, ReleasesHelper } from '../core/helpers';

@Injectable()
export class FishMapService {

    factoriesHelper: FactoriesHelper;
    catchesHelper: CatchesHelper;
    recapturesHelper: RecapturesHelper;
    releasesHelper: ReleasesHelper
    fishType:string;

    constructor(
        private http: HttpClient,
        private appSettings: AppSettings) {
        this.factoriesHelper = new FactoriesHelper();
        this.catchesHelper = new CatchesHelper();
        this.recapturesHelper = new RecapturesHelper();
        this.releasesHelper = new ReleasesHelper();
    }

    // getICESCoordinates(): Observable<any> {
    //     return this.http.get<any>('./assets/data/_ICES_Statistical_Rectangles_Eco.json').map(response => {
    //         let features: any[] = response.features;
    //         return features.map(item => new ICESCell(item));
    //     });
    // }

    getICESCoordinates(): Observable<ICESCell[]> {
        return this.http.get<ICESCell[]>('./assets/data/ICES_Statistical_Rectangles_Eco.json');
    }

    getAllData(fishType:string): Observable<any[]> {
        // Declare observables
        this.fishType=fishType;
        let factoriesObservable = this.getFactories();
        let releasesObservable = this.getReleases();
        let recapturesObservable = this.getRecaptures();
        let catchesObservable = this.getCatches();
        let icesObservable = this.getICESCoordinates();
        let observables = [factoriesObservable, releasesObservable, recapturesObservable, catchesObservable, icesObservable];

        // Declare a fork join to load data together
        return forkJoin(observables);
    }

    getFactories(): Observable<Factory[]> {
        // return this.http.get('./assets/data/factories.json');
        return this.http.get<any[]>(`${this.appSettings.apiFactoriesUrl}/${this.fishType}`).pipe(map(response => {
            return response.map(item => this.factoriesHelper.createFactory(item));
        }));
    }

    getCatches(): Observable<Catch[]> {
        // return this.http.get('./assets/data/catches.json');
        return this.http.get<any[]>(`${this.appSettings.apiCatchesUrl}/${this.fishType}`).pipe(map(response => {
            return response.map(item => this.catchesHelper.createCatch(item));
        }));
    }

    getRecaptures(): Observable<Recapture[]> {
        // return this.http.get('./assets/data/recaptures.json');
        return this.http.get<any[]>(`${this.appSettings.apiRecapturesUrl}/${this.fishType}`).pipe(map(response => {
            return response.map(item => this.recapturesHelper.createRecapture(item));
        }));
    }

    getReleases(): Observable<Release[]> {
        // return this.http.get('./assets/data/releases.json');
        return this.http.get<any[]>(`${this.appSettings.apiReleasesUrl}/${this.fishType}`).pipe(map(response => {
            return response.map(item => this.releasesHelper.createRelease(item));
        }));
    }

    getFishTypes() {
        return this.http.get<any[]>(`${this.appSettings.apiFishTypeUrl}`).pipe(map(response => response));
    }
}